import React, { useContext } from 'react';
import { PerformanceContainer } from 'components/BoardSlideOut/Performance';
import useSlideoutDateScope from 'components/PerformanceBoards/hooks/useSlideoutDateScope';
import usePerformanceSlideOutFilterInput from 'components/PerformanceBoards/hooks/usePerformanceSlideOutFilterInput';

import useGetFieldLabel from 'hooks/useGetFieldLabel';
import PerformanceBoardSlideOutContext from 'components/PerformanceBoards/contexts/PerformanceBoardSlideOutContext';
import usePerformanceFieldsOptions from 'components/PerformanceBoards/hooks/usePerformanceFieldsOptions';
import EmptyVis from '../EmptyVis';
import EditingSectionWrapperDiv from '../EditingSectionWrapperDiv';

const PerformanceSectionContainer = ({
  section,
}: {
  section: PerformanceBoardTypes.SlideOut.PerformanceSection;
}) => {
  const { board, navState } = useContext(PerformanceBoardSlideOutContext);
  const filterInput = usePerformanceSlideOutFilterInput({
    datasetForDefaultFiltering: board.dataType,
  });
  const dateScope = useSlideoutDateScope(section.dateRange);
  const { getFieldLabel } = useGetFieldLabel();
  const { isPerformanceFieldRemoved } = usePerformanceFieldsOptions({
    initialSelectedField: section.performanceField,
  });

  const config = {
    title: section.title,
    titleLabel: section.title,
    totalField: section.performanceField,
    targetField: `${section.performanceField}Target`,
    differenceField: `${section.performanceField}Difference`,
    cadenceTotalField: section.performanceField || '',
    cadenceTargetField: `${section.performanceField}Target`,
    cadenceDifferenceField: `${section.performanceField}Difference`,
    targetHeader: `${getFieldLabel({
      field: section.performanceField || '',
      dataType: board.dataType,
    })} Target`,
    totalHeader: `${getFieldLabel({
      field: section.performanceField || '',
      dataType: board.dataType,
    })}`,
    differenceHeader: `${getFieldLabel({
      field: section.performanceField || '',
      dataType: board.dataType,
    })} Difference`,
    showReasonCode: section.isReasonCodeEnabled,
    isGridHidden: section.isGridHidden,
  };

  if (!filterInput || !dateScope) {
    return null;
  }

  if (isPerformanceFieldRemoved) {
    return <EmptyVis isFieldRemoved />;
  }

  if (navState.slideoutMode === 'Creating' || navState.editingSection) {
    return (
      <EditingSectionWrapperDiv>
        <PerformanceContainer
          filterInput={filterInput}
          dateScope={dateScope}
          config={config}
          isPerformanceBoard
          isGridHidden={section.isGridHidden}
        />
      </EditingSectionWrapperDiv>
    );
  }

  return (
    <PerformanceContainer
      filterInput={filterInput}
      dateScope={dateScope}
      config={config}
      isPerformanceBoard
      homeViz
      isGridHidden={section.isGridHidden}
    />
  );
};

export default PerformanceSectionContainer;
